import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

function TitleContainer({ StaticIntlTranslator, contextClassName }) {
  return (
    <Container className="title-container" contextClassName={contextClassName}>
      <h3 className="title">{StaticIntlTranslator}</h3>
    </Container>
  );
}

TitleContainer.propTypes = {
  StaticIntlTranslator: PropTypes.any.isRequired,
  contextClassName: PropTypes.string.isRequired,
};

export default TitleContainer;
